import { makeStyles, useTheme, MenuItem } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { getFriendlyTeamName, getTeamEventUrl, getTeamImage, numberToFraction } from '../../utils/gameUtils';

import Container from '@material-ui/core/Container';
import {
    Link,
    useParams
} from "react-router-dom";
import { getFriendlyGameDate, formatGameTime, getFriendlyDate } from '../../utils/timeFormat'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Cross from './images/cross-icon.svg'
import SelectedGraph from './images/selectedGraph.svg'
import { styles } from './LineHistoryStyles';
import { useGameQuery } from '../../hooks/useGameQuery';
import { useConfigQuery } from '../../hooks/useConfigQuery';
import ErrorView from '../../components/errors/ErrorView';
import Graph from './images/FullGame.png'
import { TeamHeader } from './TeamHeader'
import TimeImg from './images/timer.svg'
import Chart from "react-apexcharts";
import { useLineHistoryQuery } from '../../hooks/useLineHistoryQuery'
import { CircularProgress } from '@material-ui/core';
import { SportsBookLogos } from '../../utils/gameUtils';
import Select from '@material-ui/core/Select';

export default function LineHistory() {
    const classes = styles();
    const theme = useTheme();

    useEffect(() => {
        return () => {
            localStorage.removeItem('marketFilter');
        }
    }, []);

    const [showGraph, setShowGraph] = useState(false);
    const { league, gameSlug } = useParams();
    let filter = localStorage.getItem('marketFilter');
    if (!filter) {
        filter = league.toLowerCase() === 'nhl' ? 'puck_line' : league.toLowerCase() === 'mlb' ? 'run_line' : 'spread';
    }
    const [marketFilter, setMarketFilter] = useState(filter);
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const [awayTeam, rhs] = gameSlug.split('-vs-');
    const [homeTeam, dateSlug] = rhs.split('-line-history-');
    const { availableSportsBooks } = useConfigQuery();
    const [selectedBook, setSelectedBook] = useState();
    const { game, isError } = useGameQuery(league, awayTeam, homeTeam, dateSlug);
    const { isLoading, history } = useLineHistoryQuery(league, game?.id, marketFilter, selectedBook === 'BetRivers' ? 'SugarHouseNJ' : selectedBook);
    const [currentOpener, setCurrentOpener] = useState();
    const [openerSpread, setOpenerSpread] = useState();
    const [isHistoryEmpty, setIsHistoryEmpty] = useState(false);

    useEffect(() => {
        if (!isLoading && history && history.length > 0) {
            const lineName = `${marketFilter === '2way' ? 'moneyline' : marketFilter}_open`;
            const currentLine = game.consensus.lines.find((line) => line.name === lineName);
            setCurrentOpener(currentLine.outcomes);
            setOpenerSpread(currentLine.spread);
        }
        setTimeout(() => {
            if (game?.id && selectedBook && !isLoading && history && history.length === 0) {
                setIsHistoryEmpty(true);
            }
        }, 2000);
    }, [history]);

    useEffect(() => {
        setSelectedBook(availableSportsBooks[0]);
    }, [availableSportsBooks]);

    const onFilterChanged = (filter) => {
        setIsHistoryEmpty(false);
        setMarketFilter(filter);
    }

    if (isError) {
        return <ErrorView />;
    }

    if (!game) {
        return null;
    }
    
    const onChangeSportsBook = (event) => {
        setSelectedBook(event.target.value);
        setIsHistoryEmpty(false);
    }

    const imagePath = (name) => {
        let path = `${process.env.PUBLIC_URL}/images/sportBooks/${SportsBookLogos[name]}`;

        if (path.startsWith('.')) {
            path = path.substring(1);
        }

        return path;
    }

    return (
        <>
            <Container className={classes.contentContainer}>
                <div className={classes.backBtnContainer}>
                    <BackToGame game={game} league={league} />
                </div>
                <LineHistoryPageHeader
                    gameStatus={game.status}
                    league={league}
                    homeTeam={game.competitors.home}
                    awayTeam={game.competitors.away}
                    gameDate={game.scheduled_datetime}
                />
                {
                    !isLargeScreen &&
                    <div>
                        <div className={classes.mobileHeaderContainer}>
                            <div className={classes.mobileDropdownContainer}>
                            {
                                selectedBook &&
                                <Select className={classes.dropdown} onChange={onChangeSportsBook} value={selectedBook}>
                                    {availableSportsBooks.map((book, id) => (
                                        <MenuItem value={book} key={book} selected={selectedBook === book}>
                                            <img width={24} src={imagePath(book)} style={{marginRight: 12}} />
                                            {book}
                                        </MenuItem>
                                    ))}
                                </Select>
                            }
                            </div>
                            <div className={`${classes.graphIcon} ${showGraph ? classes.graphActive : ""}`} onClick={() => { setShowGraph(!showGraph) }} >
                                {
                                    showGraph ?
                                        <img src={SelectedGraph} height={28} width={28} alt='show histroy' /> :
                                        <img src={Graph} height={28} width={28} alt='show histroy' />
                                }
                            </div>
                        </div>
                        {
                            showGraph && !isLoading && history && history.length > 0 &&
                            <Charts league={league} game={game} history={history} marketFilter={marketFilter} />
                        }
                        <div className={classes.mobileMarketFilter}>
                            <MarketTypeFilter league={league} marketFilter={marketFilter} onFilterChanged={onFilterChanged} />
                        </div>
                        {
                            !isLoading && history && history.length > 0 &&
                            <OddsList game={game} league={league} history={history} currentOpener={currentOpener} marketFilter={marketFilter} openerSpread={openerSpread} />
                        }
                    </div>
                }
                {
                    isLargeScreen &&
                    <div className={classes.browserView}>
                        <div className={classes.firstPart}>
                            <div className={classes.browserHeaderContainer}>
                                <div className={classes.browserDropdownContainer}>
                                    {
                                        selectedBook &&
                                        <Select className={classes.dropdown} onChange={onChangeSportsBook} value={selectedBook}>
                                            {availableSportsBooks.map((book, id) => (
                                                <MenuItem value={book} key={book} selected={selectedBook === book}>
                                                    <img width={24} src={imagePath(book)} style={{marginRight: 12}} />
                                                    {book}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    }
                                </div>
                            </div>
                            {
                                !isLoading && history && history.length > 0 &&
                                <OddsList game={game} league={league} history={history} currentOpener={currentOpener} marketFilter={marketFilter} openerSpread={openerSpread} isLargeScreen={true} />
                            }
                        </div>
                        <div className={classes.secondPart}>
                            <div className={classes.browserView}>
                                <div className={classes.firstPart}>
                                    <div className={classes.browserHeaderContainer}>
                                        <MarketTypeFilter league={league} marketFilter={marketFilter} onFilterChanged={onFilterChanged} />
                                    </div>
                                    {
                                        !isLoading && history && history.length > 0 &&
                                        <Charts league={league} game={game} history={history} marketFilter={marketFilter} isLargeScreen={true} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    isLoading &&
                    <CircularProgress />
                }
                {
                    isHistoryEmpty &&
                    <div className={classes.marketEmptyDiv}>
                        <h6 style={{fontSize: 20}}>NO MARKET DATA AVAILABLE</h6>
                    </div>
                }
            </Container >
        </>
    );
};

const OddsList = ({game, league, history, currentOpener, marketFilter, isLargeScreen, openerSpread}) => {
    const styles = makeStyles(theme => ({
        browserTable: {
            position: 'relative',
            overscrollBehavior: 'contain',
            fontSize: 16,
        },
        table: {
            width: "100%",
            position: 'relative',
            border: 'solid var(--bd-color)',
            borderWidth: '0 1px 0 0',
            overscrollBehavior: 'contain',
            fontSize: 14,
        },
        tableRow: {
            display: 'flex',
            flexDirection: 'row',
            marginBottom: 10,
            [theme.breakpoints.down('600')]: {
                marginBottom: 0,
            },
        },
        cellHeader: {
            display: 'flex',
            flexDirection: "row",
            flex: 1.5,
            justifyContent: 'center'
        },
        timeDiv: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
        },
        timeText: {
            margin: '0 0 0 20px'
        },
        oddsCell: {
            display: 'flex',
            flex: 1
        },
        headerCol: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            "& p": {
                margin: 0
            }
        },
        openerDiv: {
            border: '1px solid #CCCED3',
            padding: '10px 0',
            [theme.breakpoints.down('600')]: {
                padding: '2px 0',
            },
        },
        openerTableRow: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: 10,
            marginBottom: 10,
            color: '#9A99A2',
            [theme.breakpoints.down('600')]: {
                marginBottom: 5,
            },
        },
        cell: {
            display: 'flex',
            flexDirection: "row",
            flex: 1.5,
            justifyContent: 'space-around'
        },
        multiCell1: {
            flex: 1,
            textAlign: 'left',
            marginLeft: 15
        },
        multiCell2: {
            flex: 2,
            textAlign: 'left',
            marginLeft: 10
        },
        rowDiv: {
            borderBottom: '1px solid #E2F0FF',
        },
        row: {
            display: 'flex',
            flexDirection: 'row',
            padding: '18px 0',
            [theme.breakpoints.down('600')]: {
                padding: '10px 0',
            },
        },
    }));
    const classes = styles();

    const getDate = (date) => {
        if (date === 'LATEST') {
            date = new Date();
        } else {
            date = new Date(date);
        }
        return date.getMonth() + 1  + '/' + date.getDate();
    }

    const getFormattedValue = (line) => {
        if (!line) {
            return <div />
        }
        return (
            <div className={classes.headerCol}>
                {
                    marketFilter === "total" && 
                    <TotalValue data={line} />
                }
                {
                    marketFilter === "2way" &&
                    line.odds
                }
                {
                    (marketFilter === "spread" || marketFilter === "puck_line" || marketFilter === "run_line") && line.spread &&
                    <div>{numberToFraction(line.spread, line.isAway ? 'spread' : '')} {line.odds}</div>
                }
            </div>
        );
    }

    return (
        <div className={isLargeScreen ? classes.browserTable : classes.table}>
            <div className={classes.tableRow}>
                <div className={classes.cellHeader}>
                    <div className={`${classes.timeDiv}`}>
                        <img src={TimeImg} width={isLargeScreen ? 30 : 22} alt="timer" />
                        <p className={classes.timeText}>Time</p>
                    </div>
                </div>
                <div className={classes.oddsCell}>
                    <div className={classes.headerCol}>
                        <TeamHeader competitor={game.competitors.away} league={league} />
                    </div>
                </div>
                <div className={classes.oddsCell}>
                    <div className={classes.headerCol}>
                        <TeamHeader competitor={game.competitors.home} league={league} />
                    </div>
                </div>
            </div>
            {
                currentOpener &&
                <div className={classes.openerDiv}>
                    <div>Opener</div>
                    <div className={classes.openerTableRow}>
                        <div className={classes.cell}>
                            <div className={classes.multiCell1}>
                                {/* {getDate(history[0]?.recorded_datetime)} */}
                            </div>
                            <div className={classes.multiCell2}>
                                {/* {formatGameTime(new Date(history[0]?.recorded_datetime))} */}
                            </div>
                        </div>
                        <div className={classes.oddsCell}>
                            {getFormattedValue({...currentOpener[0], spread: openerSpread})}
                        </div>
                        <div className={classes.oddsCell}>
                            {getFormattedValue({...currentOpener[1], spread: openerSpread, isAway: true})}
                        </div>
                    </div>
                </div>
            }
            {
                history.map((h, index) => (
                    <div className={classes.rowDiv} key={`${index}_`}>
                        <div className={classes.row}>
                            <div className={classes.cell}>
                                <div className={classes.multiCell1}>
                                    {getDate(h.recorded_datetime)}
                                </div>
                                <div className={classes.multiCell2}>
                                    {formatGameTime(h.recorded_datetime)}
                                </div>
                            </div>
                            <div className={classes.oddsCell}>
                                {getFormattedValue(h.line[0])}
                            </div>
                            <div className={classes.oddsCell}>
                                {getFormattedValue(h.line[1])}
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    );
}

const Charts = ({league, game, history, marketFilter, isLargeScreen}) => {
    const styles = makeStyles(theme => ({
        backgroundContainer: {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        chartBackground: {
            flex: 1,
            maxWidth: 210,
            objectFit: 'contain',
            opacity: 0.1,
            margin: '0 15px',
        },
    }));
    const classes = styles();
    const img1 = getTeamImage(league, game.competitors.away);
    const img2 = getTeamImage(league, game.competitors.home);

    return (
        <>
            <div style={{ position: 'relative', width: '100%' }}>
                <div className={classes.backgroundContainer}>
                    <img src={img1} alt="chart1 background" className={classes.chartBackground} />
                    {
                        marketFilter === 'total' &&
                        <img src={img2} alt="chart2 background" className={classes.chartBackground} />
                    }
                </div>
                <ChartComp team={0} history={history} marketFilter={marketFilter} isLargeScreen={isLargeScreen} />
            </div>
            {
                marketFilter !== 'total' &&
                <div style={{ position: 'relative', width: '100%' }}>
                    <div className={classes.backgroundContainer}>
                        <img src={img2} alt="chart2 background" className={classes.chartBackground} />
                    </div>
                    <ChartComp team={1} history={history} marketFilter={marketFilter} isLargeScreen={isLargeScreen} />
                </div>
            }
        </>
    );
}

const ChartComp = ({team, history, marketFilter, isLargeScreen}) => {
    const styles = makeStyles(theme => ({
        mobileChartContainer: {
            border: '1px solid #CCCED3',
            margin: '10px 0',
        },
        chartContainer: {
            boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.15)',
            marginBottom: 32,
            borderRadius: 4,
            border: '1px solid #CCCCCC',
        },
    }));
    const classes = styles();
    const xData = [];
    const yData = [];
    const filteredData = history.filter(h => h.line[team]);
    let marketFilterStr = marketFilter;
    if (marketFilter === '2way') {
        marketFilterStr = 'odds';
    } else if (marketFilter === 'run_line' || marketFilter === 'puck_line') {
        marketFilterStr = 'spread';
    }
    filteredData.forEach((h, i) => {
        if (xData.includes(getFriendlyDate(h.recorded_datetime))) {
            if (i !== filteredData.length - 1) {
                xData.push('');
            } else {
                if (xData.filter(x => x).length === 1) {
                    xData.push(getFriendlyDate(h.recorded_datetime));
                }
            }
        } else {
            xData.push(getFriendlyDate(h.recorded_datetime));
        }
        yData.push(h.line[team][marketFilterStr]);
    });

    const series = [
        {
            name: '',
            data: yData,
        }
    ];

    const options = {
        
        tooltip: {
            x: {
                formatter: (i, x) => {
                    const selected = filteredData[i - 1];
                    return selected ? formatGameTime(selected.recorded_datetime) : '';
                }
            },
            y: {
                formatter: (val, y) => {
                    const selected = filteredData[y.dataPointIndex];
                    if (marketFilter === '2way') {
                        return val;
                    } else if (marketFilterStr === 'spread') {
                        return selected ? selected.line[team][marketFilterStr] + ' ' + selected.line[team].odds : val;
                    } else {
                        let tooltipStr = val;
                        if (selected) {
                            tooltipStr = selected.line[team][marketFilterStr] + ' ';
                            tooltipStr += (selected.line[0].type === 'over' ? 'o' : 'u') + selected.line[0].odds + ' ';
                            tooltipStr += (selected.line[1].type === 'over' ? 'o' : 'u') + selected.line[1].odds;
                        }
                        return tooltipStr;
                    }
                }
            }
        },
        chart: {
            height: 350,
            type: 'line',
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'straight', // 'smooth' is available, too
            width: 2
        },
        grid: {
            borderColor: '#9A99A2',
            strokeDashArray: 2,
            position: 'back',
            row: {
                colors: ['transparent', 'transparent'],
                opacity: 0.5
            },
        },
        xaxis: {
            categories: xData,
        },
        yaxis: {
            show: true,
            showAlways: true,
            showForNullSeries: true,
            seriesName: undefined,
            opposite: false,
            reversed: false,
            logarithmic: false,
            tickAmount: 3,
            forceNiceScale: false,
            floating: false,
            decimalsInFloat: undefined,
            labels: {
                show: true,
                align: 'right',
                minWidth: 0,
                maxWidth: 160,
                style: {
                    colors: [],
                    fontSize: '12px',
                    fontWeight: 400,
                    cssClass: 'apexcharts-yaxis-label',
                },
                offsetX: 0,
                offsetY: 0,
                rotate: 0,
            },
        },
        colors: team === 0 ? ["#FF6B00"] : ["#074589"],
        redrawOnParentResize: true,
        markers: {
            size: 5,
            strokeColors: team === 0 ? "#FF6B00" : "#074589",
            colors: ["#fff"],
            strokeWidth: 2,
            hover: {
                size: 7,
            },
        }
    }

    return (
        <div className={isLargeScreen ? classes.chartContainer : classes.mobileChartContainer}>
            <Chart options={options} series={series} height={isLargeScreen ? 350 : 250} />
        </div>
    );
};

const LineHistoryPageHeader = ({ league, gameStatus, homeTeam, awayTeam, gameDate }) => {
    const styles = makeStyles(theme => ({
        vs: {
            fontSize: 28,
            [theme.breakpoints.down('xs')]: {
                fontSize: '18px',
            },
        },
        container: {
            marginTop: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            fontFamily: 'proxima-nova',
            "& h3": {
                margin: 0,
                padding: 0,
                fontFamily: 'proxima-nova',
                fontWeight: 800,
                marginRight: 8,
                fontSize: '35px',
                lineHeight: '100%',
                [theme.breakpoints.down('xs')]: {
                    fontSize: '25px',
                },
                letterSpacing: '-1px',
                textTransform: 'uppercase',
            },
            "& p": {
                marginTop: '4px',
                fontFamily: 'proxima-nova',
                padding: 0,
                fontSize: 14,
                fontWeight: 400
            }
        },
    }));
    const classes = styles();
    const awayTeamName = getFriendlyTeamName(league, homeTeam, true);
    const homeTeamName = getFriendlyTeamName(league, awayTeam, true);
    function getFriendlyGameTime(d) {
        d = new Date(d);
        const date = getFriendlyGameDate(d, true);
        return date + " " + formatGameTime(d);
    }
    const isPostponed = gameStatus === 'postponed';
    const isCancelled = gameStatus === 'cancelled';
    const isClosed = gameStatus === 'closed';
    return (
        <div className={classes.container}>
            <h3>
                <span>{homeTeamName}</span>
                <span className={classes.vs}> vs </span>
                <span>{awayTeamName}</span>
            </h3>
            <h3>
                <span>LINE HISTORY</span>
            </h3>
            {isPostponed ? <p>Postponed</p> : isCancelled ? <p>Cancelled</p> : isClosed ? <p>Closed</p> : <p>{getFriendlyGameTime(gameDate).toLocaleUpperCase()}</p>}
        </div>
    )
}

function TotalValue({data}) {
    let overUnderTotal;
    if (data?.total) {
        if (data['type'] === 'over') {
            overUnderTotal = 'o' + data['total'];
        } else {
            overUnderTotal = 'u' + data['total'];
        }
        return (
            <>
                <div>{numberToFraction(overUnderTotal)}<span>&nbsp;</span>{data.odds}</div>
            </>
        );
    }
    return <div></div>
}

function MarketTypeFilter({ marketFilter, onFilterChanged, league, }) {
    const styles = makeStyles(theme => ({
        tabs: {
            borderBottom: '1px solid #DADADA',
            borderTop: '1px solid #DADADA',
            position: 'sticky',
            zIndex: 10,
            top: '95px',
            padding: 0,
            marginTop: '-14px',
        },
        tab: {
            fontFamily: 'Open Sans',
        },
        container: {
            borderBottom: '1px solid #D1CFD7',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            listStyle: 'none',
            fontSize: '0.9rem',
            fontFamily: 'Open Sans',
            position: 'sticky',
            backgroundColor: 'white',
            padding: '10px 0',
            zIndex: 10,
    
            '& li': {
                cursor: 'pointer',
                borderRadius: 8,
                border: '1px solid #9A99A2',
                minWidth: "23%",
                height: 27,
                fontSize: 14,
                marginRight: 6,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
    
                '& select': {
                    border: 'none',
                    height: '100%',
                },
                '&:last-of-type': {
                    marginRight: 0,
                },
                '&:first-of-type': {
                    flex: 1,
                }
            }
        },
        browserContainer: {
            display: 'flex',
            width: "100%",
            flexDirection: 'row',
            alignItems: 'center',
            listStyle: 'none',
            justifyContent: 'space-between',
            fontSize: '0.9rem',
            fontFamily: 'Open Sans',
            backgroundColor: 'white',
            zIndex: 10,
    
            '& li': {
                cursor: 'pointer',
                borderRadius: 8,
                border: '1px solid #D1CFD7',
                minWidth: "23%",
                height: 38,
                lineHeight: '150%',
                marginRight: 6,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: 16,
                overflow: 'hidden',
                '&:last-of-type': {
                    marginRight: 0
                }
            }
        },
        selected: {
            fontWeight: '700 !important',
            [theme.breakpoints.up('sm')]: {
                backgroundColor: '#074589',
                color: 'white'
            },
            [theme.breakpoints.down('xs')]: {
                backgroundColor: '#074589',
                color: 'white'
            }
        },
        fullGameSelector: {
            border: "none !important",
            width: '100%',
            height: '100%',
            // background: `url(${Arrow}) no-repeat right #fff !important`,
            '-webkit-appearance': 'none !important',
            backgroundPositionX: "90% !important",
            fontSize: 16,
            outline: 'none',
            padding: '0 20px',
            backgroundColor: '#fff',
            textAlign: 'left',
        },
        optContainer: {
            minWidth: '25% !important',
            overflow: 'hidden important',
        }
    }));
    const classes = styles();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const leagueName = league.toLowerCase();

    const changeFilter = (filter) => {
        if (onFilterChanged) {
            onFilterChanged(filter);
        }
    }

    function isSelected(filter) {
        return filter === marketFilter ? classes.selected : "";
    }

    if (isLargeScreen) {
        return (<div className={classes.browserContainer}>
            <li key={'fullGame'} className={classes.optContainer}>
                {/* <select className={classes.fullGameSelector}>
                    <option value='1' disabled>Full Game</option>
                </select> */}
                <button className={classes.fullGameSelector}>Full Game</button>
            </li>
            {
                (leagueName === 'mlb' || leagueName === 'nhl') &&
                <li key={'moneyline'} onClick={() => changeFilter("2way")} className={isSelected('2way')}>Moneyline</li>
            }
            {
                leagueName === 'nhl' &&
                <li key={'puckLine'} onClick={() => changeFilter("puck_line")} className={isSelected('puck_line')}>Puck
                Lines</li>
            }
            {
                leagueName === 'mlb' &&
                <li key={'runLine'} onClick={() => changeFilter("run_line")} className={isSelected('run_line')}>Run
                Lines</li>
            }
            {
                (leagueName !== 'mlb' && leagueName !== 'nhl') &&
                <>
                    <li key={'spread'} onClick={() => changeFilter("spread")} className={isSelected('spread')}>Spread</li>
                    <li key={'moneyline'} onClick={() => changeFilter("2way")} className={isSelected('2way')}>Moneyline</li>
                </>
            }
            <li key={'total'} onClick={() => changeFilter("total")} className={isSelected('total')}>Total</li>
        </div>
        )
    } else {
        return (
            <div className={classes.container}>
                <li key={'fullGame'} className={classes.optContainer}>
                    {/* <select className={classes.Option}>
                        <option value='1'>Full Game</option>
                    </select> */}
                    Full Game
                </li>
                {
                    (leagueName === 'mlb' || leagueName === 'nhl') &&
                    <li key={'moneyline'} onClick={() => changeFilter("2way")} className={isSelected('2way')}>Moneyline</li>
                }
                {
                    leagueName === 'nhl' &&
                    <li key={'puckLine'} onClick={() => changeFilter("puck_line")} className={isSelected('puck_line')}>Puck Lines</li>
                }
                {
                    leagueName === 'mlb' &&
                    <li key={'runLine'} onClick={() => changeFilter("run_line")} className={isSelected('run_line')}>Run Lines</li>
                }
                {
                    (leagueName !== 'mlb' && leagueName !== 'nhl') &&
                    <>
                        <li key={'spread'} onClick={() => changeFilter("spread")} className={isSelected('spread')}>Spread</li>
                        <li key={'moneyline'} onClick={() => changeFilter("2way")} className={isSelected('2way')}>Moneyline</li>
                    </>
                }
                <li key={'total'} onClick={() => changeFilter("total")} className={isSelected('total')}>Total</li>
            </div>
        );
    }
}

const BackToGame = ({ game, league }) => {
    let url = getTeamEventUrl(league, game);
    return (
        <Link to={url}>
            <img alt="cross button" src={Cross} />
        </Link>
    );
}